import { useTheme } from "@mui/material/styles"
import { Area, AreaChart, ResponsiveContainer } from "recharts"

import { PoolHistoricalPnlPool } from "../../types"

export default function TotalAssetsValueChart({ pools }: { pools: PoolHistoricalPnlPool[] }) {
  const theme = useTheme()

  const dates = Array.from(
    new Set(pools.flatMap((pool) => pool.historical_pnl.map((entry) => entry.dt))),
  )
  const last7Days = dates.slice(-7)

  const data: { name: string; volume_usd: number }[] = []

  for (const day of last7Days) {
    const dayData = pools
      .flatMap((pool) =>
        pool.historical_pnl
          .filter((entry) => entry.dt === day)
          .map((entry) => ({
            name: entry.dt,
            volume_usd: entry.tvl_user,
          })),
      )
      .sort((a, b) => new Date(a.name).getTime() - new Date(b.name).getTime())

    const previousDayValue = data[data.length - 1]?.volume_usd || 0
    const dayDataTotal = dayData.reduce((acc, entry) => acc + entry.volume_usd, previousDayValue)

    if (dayData.length === 0) {
      data.push({ name: day, volume_usd: 0 })
    } else {
      data.push({ name: day, volume_usd: dayDataTotal })
    }
  }

  return (
    <ResponsiveContainer width={"100%"} height={120}>
      <AreaChart
        data={data}
        margin={{
          top: 10,
          right: 0,
          left: 0,
          bottom: 0,
        }}
      >
        <defs>
          <linearGradient id="first" x1="0" y1="0" x2="0" y2="1">
            <stop offset="30%" stopColor={theme.palette.accent.main} stopOpacity={1} />
            <stop offset="95%" stopColor={theme.palette.accent.main} stopOpacity={0.1} />
          </linearGradient>
        </defs>
        <Area
          type="linear"
          dataKey="volume_usd"
          dot={true}
          stroke={theme.palette.accent.main}
          fill="url(#first)"
        />
      </AreaChart>
    </ResponsiveContainer>
  )
}
